import { historie } from './history.js';
import { myToolbar } from './tools/toolbar.js';
import { myInput } from './input.js';
import { doBeading } from './tools/beading.js';
import { mirror } from './tools/mirror.js';
import { beads } from './beads.js';
import { settings } from './settings.js';
import { menu } from './menu.js';
import { modes } from './modes.js';
import { palette } from './palette.js';
import { guides } from './view/guides.js';

export default [
    {
        name: 'ALT',
        onDown: () => {
            if (modes.currentMode.name === 'draw') {
                myToolbar.focus('Eyedropper');
            }
            if (modes.currentMode.name === 'rectangle') {
                myToolbar.focus('Eyedropper');
            }
        },
        onUp: () => {
            if (modes.currentMode.name === 'draw') {
                myToolbar.focus('Draw');
            }
            if (modes.currentMode.name === 'rectangle') {
                myToolbar.focus('Rectangle');
            }
        }
    },
    {
        name: 'SHIFT',
        onDown: () => {
            if (modes.currentMode.name === 'beading') {
                doBeading.changeOrientation();
            }
            if (modes.currentMode.name === 'draw') {
                myToolbar.focus('Erase');
            }
        },
        onUp: () => {
            if (modes.currentMode.name === 'draw') {
                myToolbar.focus('Draw');
            }
        }
    },
    {
        name: 'BACKSPACE',
        onDown: () => {
            if (!modes.currentMode.backspace) return
            modes.currentMode.backspace();
        },
        onUp: () => {
            if (modes.currentMode.name === 'beading') {
                myInput.keyReleased = true;
            }
        }
    },
    {
        name: 'ENTER',
        onDown: () => {
            if (modes.currentMode.name === 'beading') {
                if (myInput.keyReleased) {
                    doBeading.next();
                    myInput.keyReleased = false;
                }
            }
            if (beads.mirror.active) {
                mirror.rotate();
            }
        },
        onUp: () => {
            if (modes.currentMode.name === 'beading') {
                myInput.keyReleased = true;
            }
        }
    },
    {
        name: 'ESC',
        onDown: () => {
            if (modes.currentMode.name === 'beading') {
                modes.start('draw');
            } else {
                menu.closePanels();
            }
        }
    },
    {
        name: 'A',
        onDown: () => palette.selectAll()
    },
    {
        name: 'C',
        onDown: () => {
            if (myInput.ALT.isDown) {
                beads.copy();
            }
        }
    },
    {
        name: 'D',
        onDown: () => modes.start('draw')
    },
    {
        name: 'E',
        onDown: () => modes.start('erase')
    },
    {
        name: 'G',
        onDown: () => menu.showGuides(!guides.arr.length)
    },
    {
        name: 'H',
        onDown: () => modes.start('hand')
    },
    {
        name: 'I',
        onDown: () => palette.inverse()
    },
    {
        name: 'M',
        onDown: () => modes.start('marquee')
    },
    {
        name: 'P',
        onDown: () => myToolbar.isDisabled('Paint') ? null : modes.start('paint')
    },
    {
        name: 'Q',
        onDown: () => settings.toggleLetterCodes()
    },
    {
        name: 'R',
        onDown: () => modes.start('rectangle')
    },
    {
        name: 'S',
        onDown: () => modes.start('select')
    },
    {
        name: 'U',
        onDown: () => settings.toggleInactiveBeads()
    },
    {
        name: 'V',
        onDown: () => {
            if (myInput.ALT.isDown) {
                beads.paste();
            }
        }
    },
    {
        name: 'Y',
        onDown: () => modes.start('eyedropper')
    },
    {
        name: 'W',
        onDown: () => modes.start('wand')
    },
    {
        name: 'X',
        onDown: () => menu.setSimpleMode(!settings.renderColorOnly)
    },

    {
        name: 'Z',
        onDown: () => {
            if (myInput.ALT.isDown) {
                historie.undo();
                beads.unselectAll();
            }
        }
    },
];
